module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "crm-wrapper"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.unHandleHandleShow),
      expression: "unHandleHandleShow"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "enquiries notice-state-wrap"
  }, [_c('div', {
    staticClass: "enquiries-title"
  }, [_c('span'), _vm._v(_vm._s(_vm.$t('handle_local.handle.unHandle')) + "\n                ")]), _vm._v(" "), _vm._l((_vm.handleItems), function(item) {
    return _c('div', {
      key: item,
      staticClass: "notice-manage-wrap"
    }, [_c('div', {
      staticClass: "notice-manage-content",
      on: {
        "click": function($event) {
          _vm.jumpToApproval(item.formUrl)
        }
      }
    }, [_c('div', {
      staticClass: "d-flex justify-content-between"
    }, [_c('div', {
      staticStyle: {
        "width": "60%"
      }
    }, [_c('t-tooltip', {
      attrs: {
        "content": item.title,
        "placement": "bottom"
      }
    }, [_c('span', {
      staticClass: "do-left"
    }, [_vm._v(_vm._s(item.title))])])], 1), _vm._v(" "), _c('div', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(item.workflowCreateDate))])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-row-reverse mt-10"
  }, [_c('t-button', {
    on: {
      "click": _vm.jumpToUnHandle
    }
  }, [_vm._v("more")])], 1)], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "enquiries notice-state-wrap"
  }, [_c('div', {
    staticClass: "enquiries-title"
  }, [_c('span'), _vm._v(_vm._s(_vm.$t('handle_local.handle.handle')) + "\n                ")]), _vm._v(" "), _vm._l((_vm.unHandleItems), function(item) {
    return _c('div', {
      key: item,
      staticClass: "notice-manage-wrap"
    }, [_c('div', {
      staticClass: "notice-manage-content",
      on: {
        "click": function($event) {
          _vm.jumpToApproval(item.formUrl)
        }
      }
    }, [_c('div', {
      staticClass: "d-flex justify-content-between"
    }, [_c('div', {
      staticStyle: {
        "width": "60%"
      }
    }, [_c('t-tooltip', {
      attrs: {
        "content": item.title,
        "placement": "bottom"
      }
    }, [_c('span', {
      staticClass: "do-left"
    }, [_vm._v(_vm._s(item.title))])])], 1), _vm._v(" "), _c('div', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(item.workflowCreateDate))])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-row-reverse mt-10"
  }, [_c('t-button', {
    on: {
      "click": _vm.jumpToHandle
    }
  }, [_vm._v("more")])], 1)], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "enquiries mt-10",
    staticStyle: {
      "padding": "0px 0px 15px 0px"
    }
  }, [_c('div', {
    staticClass: "notice-list-title"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between"
  }, [_c('div', [_c('span', {
    staticClass: "span"
  }), _vm._v(_vm._s(_vm.$t('notice_local.notice.list_title')) + "\n                ")]), _vm._v(" "), _c('div', [_c('t-input', {
    attrs: {
      "icon": "magnify",
      "icon-placement": "right"
    },
    nativeOn: {
      "click": function($event) {
        _vm.handleChooseRole($event)
      }
    },
    model: {
      value: (_vm.bulletinTitle),
      callback: function($$v) {
        _vm.bulletinTitle = $$v
      },
      expression: "bulletinTitle"
    }
  })], 1)])]), _vm._v(" "), _vm._l((_vm.items), function(item) {
    return (_vm.total != 0) ? _c('div', {
      key: item,
      staticClass: "notice-manage-wrap",
      on: {
        "click": function($event) {
          _vm.navToDetail(item)
        }
      }
    }, [_c('div', {
      staticClass: "notice-manage-content"
    }, [_c('div', {
      staticClass: "text-left content-title"
    }, [(parseInt(item.topFlag) === 1) ? _c('t-tag', {
      attrs: {
        "state": "warning"
      }
    }, [_vm._v(_vm._s(_vm.$t('notice_local.notice.list_tag_top')))]) : _vm._e(), _vm._v(" "), (parseInt(item.bulletinLevel) === 3) ? _c('t-tag', {
      attrs: {
        "state": "success"
      }
    }, [_vm._v(_vm._s(_vm.$t('notice_local.notice.list_tag_emergency')))]) : _vm._e(), _vm._v(" "), (parseInt(item.bulletinLevel) === 2) ? _c('t-tag', {
      attrs: {
        "state": "info"
      }
    }, [_vm._v(_vm._s(_vm.$t('notice_local.notice.list_tag_important')))]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.bulletinTitle))])], 1), _vm._v(" "), _c('div', {
      staticClass: "text-right content-time"
    }, [_vm._v(_vm._s(item.createTimeString))])])]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "notice-pager mt-10",
    staticStyle: {
      "margin": "20px 0px 5px 0px !important"
    }
  }, [_c('t-pager', {
    attrs: {
      "total": _vm.total,
      "page-size": _vm.pageSize,
      "sizer-range": _vm.sizerRange,
      "show-elevator": "",
      "show-sizer": ""
    },
    on: {
      "on-change": _vm.handleOnPagerChange,
      "on-size-change": _vm.handleOnPagerSizeChange
    }
  })], 1)], 2), _vm._v(" "), _c('slide-component', {
    staticStyle: {
      "padding-top": "10px"
    },
    attrs: {
      "title": _vm.$t('my_task.myTasks')
    },
    on: {
      "ievent": function($event) {
        _vm.ievent('basicInfoDiv', _vm.basicInfoDiv)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.basicInfoDiv),
      expression: "basicInfoDiv"
    }],
    staticClass: "enquiries mt-10",
    staticStyle: {
      "padding": "0px 0px 15px 0px"
    }
  }, [_c('div', {
    staticClass: "notice-list-title"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-5 col-lg-5 col-xl-5"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-7 col-lg-7 col-xl-7"
  }, [_c('div', {
    staticClass: "d-flex justify-content-start"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4",
    staticStyle: {
      "font-size": ".875rem",
      "padding": "1.3% 0 0 0",
      "font-weight": "400",
      "text-align": "right",
      "color": "#868e8f"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('my_task.taskListFilter')) + "\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"
  }, [_c('t-select', {
    on: {
      "on-change": _vm.changeTaskListFilter
    },
    model: {
      value: (_vm.filterType),
      callback: function($$v) {
        _vm.filterType = $$v
      },
      expression: "filterType"
    }
  }, _vm._l((_vm.changeTaskListFilterList), function(item) {
    return _c('t-option', {
      key: item.value,
      attrs: {
        "value": item.value
      }
    }, [_vm._v("\n                                    " + _vm._s(_vm.lang.indexOf('zh') != -1 ? (item.label_zh ? item.label_zh : item.label) : item.label) + "\n                                ")])
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "manag-rt-btn"
  }, [_c('t-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.handleJumpToAdd()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('my_task.newTask')))])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "selectTable"
  }, [_c('div', {
    staticClass: "enquiries-tab res-selectTable"
  }, [_c('div', {
    staticClass: "cmi-tab mt-15 table-aa"
  }, [_c('t-table', {
    attrs: {
      "border": "",
      "columns": _vm.columns,
      "data": _vm.queryData,
      "all-ellipsis": true
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "notice-pager mt-10",
    staticStyle: {
      "margin": "20px 0px 5px 0px !important"
    }
  }, [_c('t-pager', {
    attrs: {
      "total": _vm.taskTotal,
      "page-size": _vm.taskPageSize,
      "show-elevator": "",
      "show-sizer": ""
    },
    on: {
      "on-change": _vm.handleOnTaskPagerChange,
      "on-size-change": _vm.handleOnTaskPagerSizeChange
    }
  })], 1)])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d6e5db8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/notice-list.vue
// module id = 87
// module chunks = 0